import React from 'react';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../services/proptypes';

const propTypes = {
  children: ChildrenPropType,
};

const defaultProps = {
  children: null,
};

/**
 * This can be used to group items. For instance,
 * <Menu position="right">
 *    <Link {...someProps} />
 *    <Link {...someOtherProps} />
 *    <Link {...thirdProps} />
 * </Menu>
 */
function Menu({ children, ...menuProps }) {
  return (
    <SemanticUIMenu.Menu className="site-navigation-menu" {...menuProps}>
      {children}
    </SemanticUIMenu.Menu>
  );
}

Menu.propTypes = propTypes;
Menu.defaultProps = defaultProps;

export default Menu;
